import { Skeleton } from 'modules/v2/foundation/Skeleton';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { useLoad } from '../Table/hooks/useLoad';
import { TableBodyCell } from '../TableCell';
import { TableRow } from '../TableRow';
import { StyledTableBody } from './styled';
export function TableBody(props) {
    const { children } = props;
    const { initialLoading, loadingRows, loadingColumns } = useLoad();
    const getSkeletonWidth = () => `${Math.floor(Math.random() * (80 - 60) + 60)}%`;
    if (initialLoading) {
        return (<StyledTableBody>
        {Array.from(Array(loadingRows).keys()).map((row) => (<TableRow key={row} disabled>
            {Array.from(Array(loadingColumns).keys()).map((cell) => (<TableBodyCell key={cell} headers="">
                <Skeleton loading width={getSkeletonWidth()} height={pxToRem(16)}/>
              </TableBodyCell>))}
          </TableRow>))}
      </StyledTableBody>);
    }
    return <StyledTableBody>{children}</StyledTableBody>;
}
